import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Pagination = ({ totalItems, itemsPerPage, onPageChange }) => {
  const [currentPage, setCurrentPage] = useState(1);

  // Calculate total number of pages
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  // Function to handle page change
  const handlePageChange = (page) => {
    setCurrentPage(page);
    onPageChange(page); // Call the callback function passed as prop
  };

  // Generate page numbers dynamically
  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  return (
    <ul className="pagination flex-center flex-wrap gap-16">
      {/* Previous Button */}
      <li className="page-item">
        <Link
          className={`page-link h-64 w-64 flex-center text-xxl rounded-circle fw-medium text-neutral-600 border border-gray-100 ${currentPage === 1 ? 'disabled' : ''}`}
          to="#"
          onClick={(e) => {
            e.preventDefault();
            if (currentPage > 1) handlePageChange(currentPage - 1);
          }}
        >
          <i className="ph-bold ph-arrow-left" />
        </Link>
      </li>

      {/* Page Number Links */}
      {pageNumbers.map((page) => (
        <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
          <Link
            className="page-link h-64 w-64 flex-center text-md rounded-circle fw-medium text-neutral-600 border border-gray-100"
            to="#"
            onClick={(e) => {
              e.preventDefault();
              handlePageChange(page);
            }}
          >
            {page}
          </Link>
        </li>
      ))}

      {/* Next Button */}
      <li className="page-item">
        <Link
          className={`page-link h-64 w-64 flex-center text-xxl rounded-circle fw-medium text-neutral-600 border border-gray-100 ${currentPage === totalPages ? 'disabled' : ''}`}
          to="#"
          onClick={(e) => {
            e.preventDefault();
            if (currentPage < totalPages) handlePageChange(currentPage + 1);
          }}
        >
          <i className="ph-bold ph-arrow-right" />
        </Link>
      </li>
    </ul>
  );
};

export default Pagination;
